const SESSION_KEY = 'th_session'
const ATTEMPTS_KEY = 'th_login_attempts'
const ACTIVITY_KEY = 'th_activity'
const SESSION_TIMEOUT_MS = 30 * 60 * 1000  // 30 minutes
const MAX_ATTEMPTS = 5
const LOCKOUT_DURATION_MS = 15 * 60 * 1000 // 15 minutes

const API_BASE = '/api'

export async function login(username, password) {
  const response = await fetch(`${API_BASE}/login.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ username, password })
  })

  if (!response.ok) {
    throw new Error('Invalid credentials')
  }

  const { token } = await response.json()
  createSession(token)
  return true
}

export function getAuthToken() {
  try {
    const data = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null')
    return data?.token || null
  } catch {
    return null
  }
}

export function recordLogin() {
  localStorage.setItem(ACTIVITY_KEY, JSON.stringify({ lastLogin: new Date().toISOString() }))
}

export function getLastLogin() {
  try {
    const data = JSON.parse(localStorage.getItem(ACTIVITY_KEY) || 'null')
    return data?.lastLogin || null
  } catch {
    return null
  }
}

export function getLockoutStatus() {
  try {
    const data = JSON.parse(localStorage.getItem(ATTEMPTS_KEY) || '{}')
    const { count = 0, lockedUntil = 0 } = data
    const now = Date.now()
    if (lockedUntil > now) {
      const minutesLeft = Math.ceil((lockedUntil - now) / 60000)
      return { locked: true, minutesLeft, count }
    }
    if (lockedUntil && lockedUntil <= now) {
      localStorage.removeItem(ATTEMPTS_KEY)
      return { locked: false, count: 0 }
    }
    return { locked: false, count }
  } catch {
    return { locked: false, count: 0 }
  }
}

export function recordFailedAttempt() {
  try {
    const data = JSON.parse(localStorage.getItem(ATTEMPTS_KEY) || '{}')
    const count = (data.count || 0) + 1
    const lockedUntil = count >= MAX_ATTEMPTS ? Date.now() + LOCKOUT_DURATION_MS : (data.lockedUntil || 0)
    localStorage.setItem(ATTEMPTS_KEY, JSON.stringify({ count, lockedUntil }))
    return { count, locked: count >= MAX_ATTEMPTS }
  } catch {
    return { count: 1, locked: false }
  }
}

export function clearFailedAttempts() {
  localStorage.removeItem(ATTEMPTS_KEY)
}

export function createSession(token) {
  const session = { token, createdAt: Date.now(), lastActive: Date.now() }
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function isSessionValid() {
  try {
    const data = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null')
    if (!data) return false
    const now = Date.now()
    if (now - data.lastActive > SESSION_TIMEOUT_MS) {
      destroySession()
      return false
    }
    data.lastActive = now
    localStorage.setItem(SESSION_KEY, JSON.stringify(data))
    return true
  } catch {
    return false
  }
}

export function refreshSession() {
  try {
    const data = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null')
    if (data) {
      data.lastActive = Date.now()
      localStorage.setItem(SESSION_KEY, JSON.stringify(data))
    }
  } catch {}
}

export function destroySession() {
  localStorage.removeItem(SESSION_KEY)
}

export function getSessionTimeRemaining() {
  try {
    const data = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null')
    if (!data) return 0
    const remaining = SESSION_TIMEOUT_MS - (Date.now() - data.lastActive)
    return Math.max(0, Math.floor(remaining / 60000))
  } catch {
    return 0
  }
}
